import React from 'react';
import { SkeletonItem } from '@atlaskit/side-navigation';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { matchUrlPathname } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { getNextgenSettingsUrl } from '@atlassian/jira-project-settings-apps-common/src/urls.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { PROJECT_SETTINGS_SHIFTER_WEIGHT } from '../../../constants.tsx';
import type { TMPSettingFeatures } from '../../../types/index.tsx';
import messages from './messages.tsx';

type AccessMenuProps = {
	projectKey: string;
	features: TMPSettingFeatures | null;
};
export const AccessMenu = ({ projectKey, features }: AccessMenuProps) => {
	const { formatMessage } = useIntl();
	const baseSettingsUrl = getNextgenSettingsUrl(SERVICE_DESK_PROJECT, projectKey);
	const tenantContext = useTenantContext();
	const { appPermissions } = tenantContext;
	const { hasServiceDeskAccess: hasJSD } = appPermissions;

	if (features == null || projectKey == null) return <SkeletonItem />;

	return (
		<>
			{hasJSD && (
				<MenuItem
					analytics={{ itemId: 'access' }}
					selectedOn={['project-settings-servicedesk-access']}
					href={`${baseSettingsUrl}/access`}
					shifter={{
						groupTitle: formatMessage(messages.title),
						context: projectKey,
						weight: PROJECT_SETTINGS_SHIFTER_WEIGHT,
					}}
				>
					{formatMessage(messages.access)}
				</MenuItem>
			)}
			<MenuItem
				analytics={{ itemId: 'customer-permissions' }}
				href={`${baseSettingsUrl}/customer-permissions`}
				selectedOn={matchUrlPathname()}
			>
				{formatMessage(messages.customerPermissions)}
			</MenuItem>
		</>
	);
};
